export const menuControl = () => {
  const headerWrapper = document.querySelector('.js-header')
  const bodyElement = document.querySelector('body')

  if (!headerWrapper || !bodyElement) {
    return
  }

  const menuWrapper = headerWrapper.querySelector('.js-header-menu')
  const menuSummon = headerWrapper.querySelector('.js-menu-summonButton')
  const menuDismiss = headerWrapper.querySelector('.js-menu-dismissButton')
  const messageWrapper = headerWrapper.querySelector('.js-header-imageWrapperNewsletterThankYou') as HTMLElement
  const imageWrapper = headerWrapper.querySelector('.js-header-imageWrapper') as HTMLElement

  if (menuSummon) {
    menuSummon.addEventListener('click', () => {
      if (menuWrapper) {
        menuWrapper.classList.remove('-isClosed')
        menuWrapper.classList.add('-isOpened')
        bodyElement.classList.add('-isLocked')
      }
    })
  }

  if (menuDismiss) {
    menuDismiss.addEventListener('click', () => {
      if (menuWrapper) {
        menuWrapper.classList.remove('-isOpened')
        menuWrapper.classList.add('-isClosing')
        bodyElement.classList.remove('-isLocked')

        setTimeout(() => {
          menuWrapper.classList.remove('-isClosing')
          menuWrapper.classList.add('-isClosed')
          imageWrapper.classList.remove('-sent')
          imageWrapper.classList.remove('-stretched')
          messageWrapper.innerHTML = ''
        }, 800)
      }
    })
  }
}
